export default "__VITE_ASSET__DIkMLc2v__"